import React from 'react'

import { Container, Main, Type, Icon, MessageWrap, Message } from './styles'

const getContent = (message, isMultiple) => {
    const marginBottom = isMultiple ? 6 : 0

    const messages =
        isMultiple &&
        message.map(msg => (
            <Message key={msg} marginBottom={marginBottom}>
                {msg}
            </Message>
        ))

    const content = isMultiple ? messages : <Message>{message}</Message>
    return content
}

const ToastNotification = props => {
    const {
        message,
        options: { icon = '', color, showIcon = true, iconPath = '' } = {},
    } = props

    const renderIcon = showIcon && (
        <Type color={color}>
            <Icon
                src={iconPath || `/assets/toast-${icon}.svg`}
                alt={'toast-icon'}
            />
        </Type>
    )

    const isMultipleMessages = Array.isArray(message)

    const messageWrapStyleProps = {
        marginLeft: `${showIcon ? 20 : 5}%`,
        padding: `${!isMultipleMessages ? 0 : 10}px 10px 0 0;`,
        flexDirection: isMultipleMessages ? 'column' : 'row',
    }
    return (
        <Container>
            <Main>
                {renderIcon}
                <MessageWrap {...messageWrapStyleProps}>
                    {getContent(message, isMultipleMessages)}
                </MessageWrap>
            </Main>
        </Container>
    )
}

export default ToastNotification
